import React, { useEffect, useState } from "react";
import { Progress } from "antd";

import "./styles.css";

const StudentsProgressBar = ({ value, text, color, trail }) => {
  const [height, setHeight] = useState(270);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2133) {
        setHeight(300);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(270);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(240);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(200);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(160);
      } else {
        setHeight(270);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  return (
    <div className="h-[9.375em] overflow-hidden flex justify-center relative pt-2">
      <Progress
        strokeLinecap="butt"
        type="dashboard"
        percent={value}
        gapDegree={180}
        strokeWidth={8}
        strokeColor={color ?? "green"}
        trailColor={trail ?? "green"}
        size={height * 0.9}
        className="student-progress-bar"
      />
      <span className="absolute top-[7.5em] font-semibold">{text}</span>
    </div>
  );
};

export default StudentsProgressBar;
